import { Component, Input, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { environment } from '../../../environments/environment'

@Component({
    selector: 'app-cosentino-svg',
    templateUrl: './cosentino-svg.component.html',
    styleUrl: './cosentino-svg.component.scss',
    standalone: true
})
export class CosentinoSvgComponent implements OnInit {
    /**
     * Nombre del fichero SVG dentro de assets/svgs/ (por ejemplo: 'icon.svg').
     */
    @Input({ required: true }) svgName: string
    /**
     * Tamaño (en píxeles) de la anchura del contenedor; la altura se ajusta proporcionalmente.
     */
    @Input({ required: true }) size: number

    svgHtml: SafeHtml

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        return this.http.get(environment.publicUrl + '/assets/svgs/' + this.svgName + '.svg', { responseType: 'text' })
            .subscribe(html => {
                html = html.replace(/fill="(?!none")[^"]*"/g, 'fill="currentColor"')
              this.svgHtml = this.sanitizer.bypassSecurityTrustHtml(html) //NOSONAR
            })
    }
}
